import { updateLiquidityCashWithJbPanelSettings } from '../../../app/api/generated/client';
import { queryKeys } from '../query-keys';
import { useLiquiditySettingsMutation } from './use-liquidity-settings-mutation';

export const useUpdateLiquidityCashWithJbPanelSettings = () =>
    useLiquiditySettingsMutation({
        mutationFn: (payload) => updateLiquidityCashWithJbPanelSettings({ body: payload, path: { id: payload.id! } }).then((result) => result.data!),
        settingsQueryKey: queryKeys.liquidityCashWithJbSettings,
        scope: 'panel',
    });
